import { baseApi } from "../../../../../app/api";
import {
  CatalogueFormPayload,
  CatalogueFormResponse,
} from "../types/catalogueApiTypes";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const catalogueApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitCatalogueForm: builder.mutation<
      CatalogueFormResponse,
      CatalogueFormPayload
    >({
      query: (payload) => {
        const apiBody = {
          ...payload,
          form_load_timestamp: payload.formLoadTimestamp,
        };
        delete (apiBody as any).formLoadTimestamp;

        return {
          url: `${CUSTOM_REST_API_BASE}/forms/catalogue`,
          method: "POST",
          body: apiBody,
        };
      },
    }),
  }),
});

export const { useSubmitCatalogueFormMutation } = catalogueApi;
